import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();

const baseUrl = '/api/tags';

export const fetchEvalTags = async () => {
    try {
        const response = await axios.get(`${baseUrl}/eval-tags`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);

        addToast('Error fetching eval tags', 'error');
        return false;
    }
}
